import { Center, Spinner } from '@chakra-ui/react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function HomeRedirect() {
  const { isSysAdmin, isAdmin, eventRoles, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (loading) return
    if (!isAdmin) {
      navigate('/', { replace: true })
      return
    }

    if (!isSysAdmin && eventRoles?.length === 1 && eventRoles[0].role === 'moderator') {
      navigate(`/events/${eventRoles[0].eventid}/moderation`, { replace: true })
      return
    }

    // navigate('/login', { replace: true })
    navigate('/events', { replace: true })
  }, [loading, isSysAdmin, isAdmin, eventRoles, navigate])

  return (
    <Center minH="60vh">
      <Spinner size="xl" />
    </Center>
  )
}
